export const SITE_COLORS = {
  primary: "#2B5AED",
  bg: "#FFFFFF",
  bgMuted: "#F5F5F5",
  footer: "#F8F8F8",
  text: "#1A1A1A",
  textMuted: "#666666",
  border: "#E5E5E5",
} as const;

export const CONTACT_INFO = {
  hotline: "+86 023 6310 9773",
  email: "support@yuouhui.com",
  address:
    "Tangli, Ma'anshan, Zaozilan'ya Zhengjie, Yuzhong District, Chongqing, China.",
  copyright:
    "Copyright©2026 Chongqing Yuou Digital Intelligence Technology (Group) Co., Ltd",
} as const;

export const APP_NAME = "yoyo";

export const PURCHASE_URL = "https://buy.stripe.com/7sYdR8eIj0UqcEq0wc7EQ03";
